import { Button, TextField, MenuItem, collapseClasses } from '@mui/material';
import axios from 'axios';
import moment from 'moment';
import TailwindModal from './TailwindModal';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import SharedOnboardingForm from './SharedOnboardingForm';
import { notify } from '../utils/ToastUtils';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { FileDown, ArrowLeft, ClipboardCheck, X, FileText } from 'lucide-react';
import { DESIGNATIONS } from '../utils/constants';
import LoaderIcon from './LoaderIcon';

const initialState = {
    Salutation: "",
    Name: "",
    Gender: "",
    Nationality: "",
    FathersName: "",
    MaritalStatus: "",
    SpouseName: "",
    BloodGroup: "",
    PhysicallyChallenged: "",
    DateOfBirth: "",
    Bank: "",
    BankBranch: "",
    IFCCode: "",
    BankAccountNumber: "",
    NameInBank: "",
    PFNo: "",
    FreshEmployement: "",
    PAN_Number: "",
    AADHAAR_Number: "",
    NamePerAadhaar: "",
    GenderPerAadhaar: "",
    DOB_Per_Aadhaar: "",
    Location: "",
    PersonalEmail: "",
    MobileNumber: "",
    EmergencyContact: "",
    RelationshipOfEmergency: "",
    PanCard: "",
    AadharCard: "",
    photo: "",
    ciia: "",
    education: ""
};

const initialoffer = {
    valid: "",
    CTC: "",
    Designation: ""
};

function SharedCandidateInfo({ token, viewMode, onBack, isUS = false }) {
    const [state, setState] = useState(initialState);
    const params = useParams();
    const actualToken = token || params.token;
    const isViewOnly = viewMode !== undefined ? viewMode : window.location.pathname.includes("view");
    const nav = useNavigate();
    const [open, setOpen] = useState(false);
    const [pdfURL, setPdfURL] = useState("");
    const [pdfLoading, setPdfLoading] = useState(false);
    const [fileExt, setFileExt] = useState("");
    const [fileNameState, setFileNameState] = useState("");
    const [valid, setvalid] = useState("");
    const [Offer, setOffer] = useState(initialoffer);
    const [formErrors, setFormErrors] = useState({});
    const [work, setWork] = useState([]);
    const [ug, setUg] = useState([]);
    const [pg, setPg] = useState([]);
    const [isVerifying, setIsVerifying] = useState(false);

    const getCandidate = async () => {
        try {
            var data = await axios.get(`${process.env.REACT_APP_BASE_URL}/admin/getCandidate`, { params: { token: actualToken } });
            data.data[0].DateOfBirth = moment(new Date(data.data[0].DateOfBirth)).format("YYYY-MM-DD");
            data.data[0].DOB_Per_Aadhaar = moment(new Date(data.data[0].DOB_Per_Aadhaar)).format("YYYY-MM-DD");
            setState(data.data[0]);
        } catch (error) {
            console.log(error);
            notify.error("Something went wrong, please try again later");
        }
    };

    const parseWork = (input, file) => {
        const [Designation, From, To] = input?.split(',') || [];
        if (!Designation && !From && !To && !file) return null;
        return { Designation, From, To, file };
    };

    const parseUgPg = (input, file) => {
        const [Degree, department, collegeName, Passed] = input?.split(',') || [];
        if (!Degree && !department && !collegeName && !Passed && !file) return null;
        return { Degree, department, collegeName, Passed, file };
    };

    useEffect(() => {
        if (state.Name !== "") {
            const outputWork = [
                parseWork(state.WORK_EXPERIENCE_1, state.WORK_EXP_CERTIFICATE_1),
                parseWork(state.WORK_EXPERIENCE_2, state.WORK_EXP_CERTIFICATE_2),
                parseWork(state.WORK_EXPERIENCE_3, state.WORK_EXP_CERTIFICATE_3),
                parseWork(state.WORK_EXPERIENCE_4, state.WORK_EXP_CERTIFICATE_4),
                parseWork(state.WORK_EXPERIENCE_5, state.WORK_EXP_CERTIFICATE_5)
            ].filter(Boolean);
            const outputUg = [
                parseUgPg(state.UG_DEGREE_1, state.UG_CERTIFICATE_1),
                parseUgPg(state.UG_DEGREE_2, state.UG_CERTIFICATE_2),
                parseUgPg(state.UG_DEGREE_3, state.UG_CERTIFICATE_3)
            ].filter(Boolean);
            const outputPg = [
                parseUgPg(state.PG_DEGREE_1, state.PG_CERTIFICATE_1),
                parseUgPg(state.PG_DEGREE_2, state.PG_CERTIFICATE_2),
                parseUgPg(state.PG_DEGREE_3, state.PG_CERTIFICATE_3)
            ].filter(Boolean);
            setWork(outputWork);
            setUg(outputUg);
            setPg(outputPg);
        }
    }, [state]);

    const verifyIntern = async () => {
        if (!valid) {
            setFormErrors({ valid: true, message: "Please Fill Offer Letter Valid Date" });
            return;
        }
        setFormErrors({});
        setIsVerifying(true);
        try {
            await axios.put(`${process.env.REACT_APP_BASE_URL}/admin/CandidateVerify`, { token: actualToken, validdate: valid });
            notify.success("Candidate Verifed Successfully");
            setTimeout(() => {
                if (onBack) onBack();
                else nav("/hr-panel");
                setIsVerifying(false);
            }, 1500);
        } catch (error) {
            console.log(error);
            notify.error("Something went wrong, please try again later");
            setIsVerifying(false);
        }
    };

    const verifyEmployee = async () => {
        const errors = {};
        if (!Offer.valid) errors.valid = true;
        if (!Offer.CTC) errors.CTC = true;
        if (!Offer.Designation) errors.Designation = true;

        if (Object.keys(errors).length > 0) {
            errors.message = "Fill mandatory Fields";
            setFormErrors(errors);
            return;
        }
        setFormErrors({});
        setIsVerifying(true);

        try {
            await axios.put(`${process.env.REACT_APP_BASE_URL}/admin/CandidateVerify`, { token: actualToken, validdate: Offer.valid, ctc: parseInt(Offer.CTC), Designation: Offer.Designation });
            notify.success("Candidate Verifed Successfully");
            setTimeout(() => {
                if (onBack) onBack();
                else nav("/hr-panel");
                setIsVerifying(false);
            }, 1500);
        } catch (error) {
            console.log(error);
            notify.error("Something went wrong, please try again later");
            setIsVerifying(false);
        }
    };

    useEffect(() => {
        return () => {
            if (pdfURL && pdfURL.startsWith('blob:')) {
                URL.revokeObjectURL(pdfURL);
            }
        };
    }, [pdfURL]);

    const showFile = async (fileName) => {
        if (fileName) {
            setOpen(true);
            setFileExt(fileName.split('.').pop().toLowerCase());
            setFileNameState(fileName);
            setPdfURL("");
            setPdfLoading(true);
            
            try {
                const fileUrl = `${process.env.REACT_APP_PUBLIC_URL}/public/onboarding/${fileName}`;
                const response = await axios.get(fileUrl, { responseType: 'blob' });
                
                if (response.data.size === 0 || response.data.type.includes('text/html')) {
                    throw new Error("Invalid document data received");
                }
                
                setPdfURL((prevUrl) => {
                    if (prevUrl && prevUrl.startsWith('blob:')) {
                        URL.revokeObjectURL(prevUrl);
                    }
                    return URL.createObjectURL(response.data);
                });
            } catch (error) {
                console.error("Failed to fetch document:", error);
            } finally {
                setPdfLoading(false);
            }
        } else notify.error("No File Found");
    };

    const downloadFile = async (fileName) => {
        const fileUrl = `${process.env.REACT_APP_PUBLIC_URL}/public/onboarding/${fileName}`;
        try {
            const response = await fetch(fileUrl);
            if (!response.ok) throw new Error("File not found or CORS blocked");
            const blob = await response.blob();
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            URL.revokeObjectURL(link.href);
        } catch (error) {
            console.error("Download failed:", error);
        }
    };

    const downloadAllOnboardingFiles = async (state, work, ug, pg) => {
        const zip = new JSZip();
        const baseUrl = `${process.env.REACT_APP_PUBLIC_URL}/public/onboarding`;

        // Collect all files with custom names
        const fileList = {
            'Passport-Photo.jpg': state.photo,
            'Aadhaar-Card.pdf': state.AadharCard,
            'PAN-Card.pdf': state.PanCard,
            '10th-Marksheet.pdf': state.tenth,
            '12th-Marksheet.pdf': state.twelth,
            'Resume.pdf': state.Resume,
            'Salary-Slips.pdf': state.SalarySlips,
            'Form-16.pdf': state.Form16,
            'ESIC-Card.pdf': state.ESICCard
        };

        // Work experience files
        work.forEach((item, i) => {
            if (item.file) fileList[`Work-Experience-${i + 1}.pdf`] = item.file;
        });

        // UG files
        ug.forEach((item, i) => {
            if (item.file) fileList[`UG-Certificate-${i + 1}.pdf`] = item.file;
        });

        // PG files
        pg.forEach((item, i) => {
            if (item.file) fileList[`PG-Certificate-${i + 1}.pdf`] = item.file;
        });

        const entries = Object.entries(fileList);

        if (entries.length === 0) {
            notify.error("No files available for download.");
            return;
        }

        await Promise.all(
            entries.map(async ([label, fileName]) => {
                if (!fileName) return;
                const fileUrl = `${baseUrl}/${fileName}`;
                try {
                    const response = await fetch(fileUrl);
                    if (!response.ok) throw new Error(`Failed to fetch: ${fileName}`);
                    const blob = await response.blob();
                    zip.file(label, blob);
                } catch (error) {
                    console.error(`Failed to fetch ${fileName}:`, error);
                }
            })
        );

        zip.generateAsync({ type: 'blob' }).then((content) => {
            saveAs(content, 'Onboarding-Files.zip');
        });
    };

    const handleInternOffer = (evt) => {
        setvalid(evt.target.value);
        if (formErrors.valid) setFormErrors({ ...formErrors, valid: false });
    };

    function handleOffer(evt) {
        setOffer({
            ...Offer,
            [evt.target.name]: evt.target.value
        });
        if (formErrors[evt.target.name]) {
            setFormErrors({ ...formErrors, [evt.target.name]: false });
        }
    }

    useEffect(() => {
        getCandidate();
    }, []);
    const verifyHandler =
    state?.TYPE === "Intern"
        ? verifyIntern
        : (state?.TYPE === "Employee" || state?.TYPE === "GT")
        ? verifyEmployee
        : null;
    return (
        <div className="d-flex">
            <div>
                <div>
                    <div>
                        <div className="bg-white rounded-lg shadow-sm border border-slate-200 p-4 xl:p-6 flex flex-col">
                            <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-4 gap-4 border-b border-slate-100 pb-3 shrink-0">
                                <div className="flex items-start gap-4">
                                    {onBack ? (
                                        <button onClick={onBack} type="button" className="p-2 mt-0.5 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors -ml-2 shrink-0">
                                            <ArrowLeft size={20} />
                                        </button>
                                    ) : (
                                        <Link to={`/hr-panel`} className="p-2 mt-0.5 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors -ml-2 shrink-0">
                                            <ArrowLeft size={20} />
                                        </Link>
                                    )}
                                    <div className="flex items-center gap-3">
                                        <div className="p-2 bg-blue-50 text-blue-600 rounded-lg border border-blue-100 shrink-0">
                                            <ClipboardCheck size={20} />
                                        </div>
                                        <div>
                                            <h3 className="text-base font-bold text-slate-800 m-0">Onboarding Details</h3>
                                            <p className="text-xs text-slate-500 mt-0.5 mb-0">Review the candidate's onboarding information and uploaded documents</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex items-center gap-2">
                                    <button type="button" onClick={() => downloadAllOnboardingFiles(state, work, ug, pg)} className="px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors text-sm font-medium shadow-sm flex items-center gap-1.5">
                                        <FileDown size={14} />
                                        <span>Download All files as ZIP</span>
                                    </button>
                                </div>
                            </div>
                            <form className='form'>
                                <div className="w-full mt-2">
                                    {(() => {
                                        let mappedState = state;
                                        const dynamicDocs = [];
                                        const dynCustomFields = [];
                                        let parsedDynamicFields = {};
                                        
                                        if (!isUS) {
                                            mappedState = {
                                                ...state,
                                                Upload_Passport_Size_photo_Copy: state.photo,
                                                Aadhaar_Card_Upload: state.AadharCard,
                                                Pan_Card_Upload: state.PanCard,
                                                Tenth_Marksheet_Upload: state.tenth,
                                                Twelth_Marksheet_Upload: state.twelth,
                                                Full_Name: state.Name,
                                                Date_of_Birth_as_per_Aadhaar: state.DOB_Per_Aadhaar,
                                                address: state.Location,
                                                Bank_Name: state.Bank,
                                                FreshEmployementForPf: state.FreshEmployement,
                                                RollNo: state.rollNo,
                                                TenthPassed: state.TENTHPASSED,
                                                TwelthPassed: state.TWELTHPASSED,
                                            };

                                            dynamicDocs.push(
                                                { fieldName: 'Resume', linkedFile: state.Resume },
                                                { fieldName: 'Salary Slips', linkedFile: state.SalarySlips },
                                                { fieldName: 'Form 16', linkedFile: state.Form16 },
                                                { fieldName: 'ESIC Card', linkedFile: state.ESICCard }
                                            );

                                            if (state.DYNAMIC_DOCUMENTS) {
                                                try {
                                                    const dynDocs = typeof state.DYNAMIC_DOCUMENTS === 'string' ? JSON.parse(state.DYNAMIC_DOCUMENTS) : state.DYNAMIC_DOCUMENTS;
                                                    Object.entries(dynDocs).forEach(([key, val]) => {
                                                        const docName = key.replace('dynamic_doc_', '');
                                                        dynamicDocs.push({ fieldName: docName, linkedFile: val });
                                                    });
                                                } catch(e) {}
                                            }
                                            
                                            if (state.DYNAMIC_FIELDS) {
                                                try {
                                                    parsedDynamicFields = typeof state.DYNAMIC_FIELDS === 'string' ? JSON.parse(state.DYNAMIC_FIELDS) : state.DYNAMIC_FIELDS;
                                                    Object.entries(parsedDynamicFields).forEach(([key, val]) => {
                                                        if (key.startsWith('dynamic_custom_file_')) {
                                                            dynCustomFields.push({ fieldName: key.replace('dynamic_custom_file_', ''), type: 'File' });
                                                        } else if (key.startsWith('dynamic_field_')) {
                                                            dynCustomFields.push({ fieldName: key.replace('dynamic_field_', ''), type: 'Text' });
                                                        }
                                                    });
                                                } catch(e) {}
                                            }
                                        }

                                        const finalDynamicDocs = dynamicDocs.filter(doc => doc.linkedFile);

                                        const mappedUg = ug?.map(form => ({
                                            ...form,
                                            UG_Provisional_Or_Degree_Certificate: form.file
                                        }));
                                        const mappedPg = pg?.map(form => ({
                                            ...form,
                                            PG_Provisional_Or_Degree_Certificate: form.file
                                        }));
                                        
                                        const displayWorkLogic = isUS ? (state?.FreshEmployement === 'No') : (state?.FreshEmployementForPf === 'No' || state?.FreshEmployement === 'No');

                                        return (
                                            <SharedOnboardingForm
                                                isUS={isUS}
                                                isReadOnly={true}
                                                type={mappedState?.TYPE}
                                                state={mappedState}
                                                ug={mappedUg}
                                                pg={mappedPg}
                                                work={work}
                                                dynamicRequiredDocs={finalDynamicDocs}
                                                dynamicCustomFields={dynCustomFields}
                                                dynamicCustomValues={parsedDynamicFields}
                                                displayWork={displayWorkLogic}
                                                showFile={showFile}
                                                downloadFile={downloadFile}
                                                diaplayPassport={state?.PASSPORT_NO !== "" ? "yes" : "no"}
                                                checked={true}
                                            />
                                        )
                                    })()}
                                </div>
                                {isUS && state?.FreshEmployement === "No" && (
                                    <h5 className='fw-bold text-muted mt-4'>Work Experience</h5>
                                )}
                                {isUS && work?.filter((ele) => ele.Designation !== "")?.map((form, index) => (
                                    <div className='row' key={`manual-work-${index}`}>
                                        <div className="col-md-3">
                                            <label htmlFor="newEmpName">Designation<span className="text-red-500 text-xs">*</span></label><br />
                                            <input className="form-control" disabled type='text' name="Designation" value={work[index].Designation} placeholder="Enter Your Designation" required />
                                        </div>
                                        <div className="col-md-3">
                                            <label htmlFor="newEmpName">From<span className="text-red-500 text-xs">*</span></label><br />
                                            <input className="form-control" disabled type='date' name="From" value={work[index].From} placeholder="Select From" required />
                                        </div>
                                        <div className="col-md-3">
                                            <label htmlFor="newEmpName">To<span className="text-red-500 text-xs">*</span></label><br />
                                            <input className="form-control" disabled type='date' name="To" value={work[index].To} placeholder="Select To" required />
                                        </div>
                                        <div className="col-md-3">
                                            <label htmlFor="newEmpName"> Experience Certificate
                                                <span className="text-red-500 text-xs">*</span></label><br />
                                            <button type="button" className="btn btn-light w-100 p-2" onClick={() => showFile(work[index].file)}>
                                                 <i className="fa fa-solid fa-eye"></i><span className='ms-1'>View</span>
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </form>
                        </div>
                        {!isViewOnly && (
                            <div className="sticky bottom-0 left-0 right-0 bg-white border-t border-slate-200 p-4 xl:p-6 z-40 rounded-b-lg">
                                {formErrors.message && (
                                    <div className="text-red-500 text-sm mb-3 font-medium">
                                        {formErrors.message}
                                    </div>
                                )}
                                <div className="flex items-end justify-between">
                                    <div className="flex-1">
                                        {state?.TYPE === "Intern" ? (
                                            <div className="flex items-center gap-4">
                                                <div className="w-64">
                                                    <label className="block text-xs font-semibold text-slate-700 mb-1">Valid Offer Letter Date <span className="text-red-500">*</span></label>
                                                    <TextField size="small" type="date" name="valid" value={valid} inputProps={{ min: moment(new Date()).format('YYYY-MM-DD') }} onChange={handleInternOffer} required fullWidth sx={{ backgroundColor: 'white', '& .MuiInputBase-root': { height: '38px' } }} error={formErrors.valid} />
                                                </div>
                                            </div>
                                        ) : (state?.TYPE === "Employee" || state?.TYPE === "GT") ? (
                                            <div className="flex items-center gap-4">
                                                <div className="w-48">
                                                    <label className="block text-xs font-semibold text-slate-700 mb-1">Valid Date <span className="text-red-500">*</span></label>
                                                    <TextField size="small" type="date" name="valid" value={Offer.valid || ''} inputProps={{ min: moment(new Date()).format('YYYY-MM-DD') }} onChange={handleOffer} required fullWidth sx={{ backgroundColor: 'white', '& .MuiInputBase-root': { height: '38px' } }} error={formErrors.valid} />
                                                </div>
                                                <div className="w-48">
                                                    <label className="block text-xs font-semibold text-slate-700 mb-1">{state.TYPE === "Employee" ? 'CTC' : 'Stipend'} <span className="text-red-500">*</span></label>
                                                    <TextField size="small" type="number" name="CTC" value={Offer.CTC || ''} placeholder={state.TYPE === "Employee" ? 'Enter CTC' : 'Enter Stipend'} onChange={handleOffer} required fullWidth sx={{ backgroundColor: 'white', '& .MuiInputBase-root': { height: '38px' } }} error={formErrors.CTC} />
                                                </div>
                                                {!isUS ? (
                                                    <div className="w-56">
                                                        <label className="block text-xs font-semibold text-slate-700 mb-1">Designation <span className="text-red-500">*</span></label>
                                                        <TextField size="small" select name="Designation" value={Offer.Designation || ''} onChange={handleOffer} required fullWidth sx={{ backgroundColor: 'white', '& .MuiInputBase-root': { height: '38px' }, '& .MuiSelect-select': { fontSize: '14px' } }} SelectProps={{ displayEmpty: true, MenuProps: { PaperProps: { sx: { maxHeight: 250 } } } }} error={formErrors.Designation}>
                                                            <MenuItem value="" disabled sx={{ fontSize: '14px', minHeight: '32px', py: 0.5, color: '#94a3b8' }}>Select Designation</MenuItem>
                                                            {DESIGNATIONS.map((desig) => (
                                                                <MenuItem key={desig} value={desig} sx={{ fontSize: '14px', minHeight: '32px', py: 0.5 }}>{desig}</MenuItem>
                                                            ))}
                                                        </TextField>
                                                    </div>
                                                ) : (
                                                    <div className="w-56">
                                                        <label className="block text-xs font-semibold text-slate-700 mb-1">Designation <span className="text-red-500">*</span></label>
                                                        <TextField size="small" name="Designation" value={Offer.Designation || ''} placeholder="Enter Designation" onChange={handleOffer} required fullWidth sx={{ backgroundColor: 'white', '& .MuiInputBase-root': { height: '38px' } }} error={formErrors.Designation} />
                                                    </div>
                                                )}
                                            </div>
                                        ) : null}
                                    </div>
                                    <div>


                                    {verifyHandler && (
                                        <Button
                                            type="button"
                                            disableElevation
                                            onClick={verifyHandler}
                                            disabled={isVerifying}
                                            className={`!normal-case h-[34px] !rounded-md !px-4 !bg-blue-600 hover:!bg-blue-700 !text-white !font-semibold !shadow-sm hover:!shadow-md transition-all duration-200 ${isVerifying ? '!opacity-80' : ''}`}
                                        >
                                            {isVerifying ? <LoaderIcon /> : "Verify"}
                                        </Button>
                                    )}
                                    </div>
                                </div>
                            </div>
                        )}
                        <TailwindModal size="lg" isOpen={open} toggle={() => setOpen(!open)}>
                            <div className={`flex flex-col ${pdfURL && !pdfLoading ? 'h-[85vh]' : ''}`}>
                                <div className="flex justify-between items-center p-4 border-b border-slate-200 shrink-0 bg-white rounded-t-xl">
                                    <h3 className="text-lg font-bold text-slate-800 m-0">Document Viewer</h3>
                                    <button onClick={() => setOpen(false)} className="p-1.5 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors">
                                        <X size={20} />
                                    </button>
                                </div>
                                <div className="p-4 flex-1 overflow-auto bg-slate-50 flex items-center justify-center rounded-b-xl">
                                    {pdfLoading ? (
                                        <div className="flex flex-col items-center justify-center py-12 text-center w-full">
                                            <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mb-4">
                                                <LoaderIcon className="w-8 h-8 text-blue-600" />
                                            </div>
                                            <h5 className="text-slate-800 font-bold mb-2">Loading document...</h5>
                                            <p className="text-slate-500 text-sm m-0">Please wait while the file is being retrieved.</p>
                                        </div>
                                    ) : pdfURL ? (
                                        ['pdf'].includes(fileExt) ? (
                                            <iframe
                                                title="PDF Viewer"
                                                src={pdfURL}
                                                className="w-full h-full rounded-lg border border-slate-200 shadow-sm"
                                            />
                                        ) : ['jpg', 'jpeg', 'png', 'gif'].includes(fileExt) ? (
                                            <img 
                                                src={pdfURL} 
                                                alt="Document Preview" 
                                                className="max-w-full max-h-full object-contain rounded-lg shadow-sm border border-slate-200" 
                                            />
                                        ) : (
                                            <div className="flex flex-col items-center justify-center p-8 bg-white rounded-xl shadow-sm border border-slate-200 text-center w-full max-w-md">
                                                <div className="w-16 h-16 bg-blue-50 text-blue-500 rounded-full flex items-center justify-center mb-4">
                                                    <FileText size={32} />
                                                </div>
                                                <h5 className="text-slate-800 font-bold mb-2">Preview not available</h5>
                                                <p className="text-slate-500 text-sm mb-6">This file format ({fileExt}) cannot be previewed inline.</p>
                                                <button type="button" onClick={() => downloadFile(fileNameState)} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm font-medium shadow-sm flex items-center gap-2">
                                                    <FileDown size={16} /> Download File
                                                </button>
                                            </div>
                                        )
                                    ) : (
                                        <div className="flex flex-col items-center justify-center py-12 text-center w-full">
                                            <div className="w-16 h-16 bg-red-50 text-red-500 rounded-full flex items-center justify-center mb-4">
                                                <X size={32} />
                                            </div>
                                            <h5 className="text-slate-800 font-bold mb-2">Failed to load document</h5>
                                            <p className="text-slate-500 text-sm m-0">The document could not be retrieved or is invalid.</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </TailwindModal>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SharedCandidateInfo;
